
import { ApiInviteCreatePostRequest, InviteApi } from "../Repository/eventbookyapi";
import { sendReminderForInvitesRequest } from "../Types/RequestResponse/createInvitesRequest copy";
import { GetApiConfiguration } from "./ServiceConfiguration";
import { eventMailDesign } from "../Components/EventDetails/EventMailDesign";

export type eventMailRequest = {
    eventId: number,
    message: string,
    design?: eventMailDesign,
    isReminder: boolean
}

export type testEventMailRequest = eventMailRequest & {
    subject: string,
    email: string
}

export abstract class InviteService {
    public static CreateInvites = async (request: ApiInviteCreatePostRequest, design?: eventMailDesign) => {
        return new InviteApi(GetApiConfiguration()).apiInviteCreatePost(
            request,
            async ({ init }) => {
                // The generated client doesn't know the design yet, so it is added to the form here.
                if (design && init.body instanceof FormData) {
                    init.body.append("Design.EmailDesignTemplate", String(Number(design.emailDesignTemplate)));
                    init.body.append("Design.Header", design.header ?? "");
                    init.body.append("Design.ImageUrl", design.imageUrl ?? "");
                    init.body.append("Design.AccentColor", design.accentColor ?? "");
                    init.body.append("Design.TextColor", design.textColor ?? "");
                }

                return init;
            }
        );
    };

    // The invite or reminder as html, the way the recipient gets it.
    public static PreviewMail = async (request: eventMailRequest): Promise<string> => {
        const response = await fetch(process.env.REACT_APP_API_URL + '/Invite/previewMail', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(request)
        });

        if (!response.ok) {
            throw Object.assign(new Error("Could not preview the mail"), { status: response.status });
        }

        return await response.text();
    };

    // Sends the invite or reminder to one address as a test. No invite is created.
    public static SendTestMail = async (request: testEventMailRequest) => {
        const response = await fetch(process.env.REACT_APP_API_URL + '/Invite/sendTestMail', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(request)
        });

        if (!response.ok) {
            throw Object.assign(new Error("Could not send the test mail"), { status: response.status });
        }
    };

    public static SendInviteReminder = async (request: sendReminderForInvitesRequest) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include' as RequestCredentials,

            body: JSON.stringify(request)
        };
        const response = await fetch(process.env.REACT_APP_API_URL + '/Invite/sendReminderForInvites', requestOptions);
        const data = await response.json();

        return data;
    };


    public static GetInvites = async (eventId: string) => {
        var options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include' as RequestCredentials
        }

        const response = await fetch(process.env.REACT_APP_API_URL + '/Invite/' + eventId, options);
        const data = await response.json();

        return data;
    };

    public static DeleteInvite = async (inviteId: string) => {
        var options = {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include' as RequestCredentials
        }

        const response = await fetch(process.env.REACT_APP_API_URL + '/Invite/' + inviteId, options);
        const data = await response.status;

        return data;
    };
};